module.exports = __webpack_public_path__ + "static/abstract-c4bf127e37c1417e1ab96221043020ec.jpg";